import React from 'react';
import { StyledInvertedSvg } from './DownCaretIcon.styles';

interface DownCaretIconProps {
  inverted: boolean;
}

// TODO replace StyledInvertedSvg with the inverted SVG code
const DownCaretIcon = ({ inverted }: DownCaretIconProps): JSX.Element =>
  inverted ? (
    <StyledInvertedSvg
      width='16'
      height='6'
      viewBox='0 0 16 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.49631 0.131867L8.00017 3.84836L14.504 0.131867C14.9835 -0.142143 15.5944 0.0244537 15.8684 0.503971C16.1424 0.983489 15.9758 1.59434 15.4963 1.86835L8.49631 5.86835C8.18888 6.04403 7.81146 6.04403 7.50403 5.86835L0.504032 1.86835C0.0245147 1.59434 -0.142082 0.983489 0.131928 0.503971C0.405938 0.0244537 1.01679 -0.142143 1.49631 0.131867Z'
        fill='#2D263B'
      />
    </StyledInvertedSvg>
  ) : (
    <svg
      width='16'
      height='6'
      viewBox='0 0 16 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.49631 0.131867L8.00017 3.84836L14.504 0.131867C14.9835 -0.142143 15.5944 0.0244537 15.8684 0.503971C16.1424 0.983489 15.9758 1.59434 15.4963 1.86835L8.49631 5.86835C8.18888 6.04403 7.81146 6.04403 7.50403 5.86835L0.504032 1.86835C0.0245147 1.59434 -0.142082 0.983489 0.131928 0.503971C0.405938 0.0244537 1.01679 -0.142143 1.49631 0.131867Z'
        fill='#2D263B'
      />
    </svg>
  );

export default DownCaretIcon;
